// src/components/layout/Header.js
import React from 'react';
import { Navbar, Nav, NavDropdown, Container, Form, Button, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
// Import desired icons
import { FaSearch, FaThLarge, FaRegCommentDots, FaRegBell, FaCog, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa'; // Added FaBars, FaTimes
// Example placeholder avatar
// import placeholderAvatar from '/placeholder-avatar.png'; // Create or replace with a real path
const placeholderAvatar = "/placeholder-avatar.png"; 

const Header = ({ toggleSidebar, isSidebarOpen }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const handleLogout = () => { logout(); navigate('/login'); };
    const changeLanguage = (lng) => { i18n.changeLanguage(lng); document.body.dir = i18n.dir(lng); };

    return (
        <div className="header-wrapper">
            <Navbar bg="light" expand="md" sticky="top" className="shadow-sm"> {/* Use md for breakpoint */}
                <Container fluid>
                    {/* Hamburger Menu Toggle for small screens */}
                    <Button
                        variant="link"
                        onClick={toggleSidebar}
                        className="me-2 sidebar-toggle-btn btn-outline-primary btn-sm" // Show on all sizes for this example, adjust 'd-md-block' as needed
                        aria-label="Toggle sidebar"
                    >
                         {/* Toggle between Bars and Times icon */}
                        {isSidebarOpen ? <FaBars /> : <FaBars />}
                    </Button>
                    {/* FinLab Brand/Logo (optional in header) */}
                     {/* <Navbar.Brand as={Link} to="/">FinLab</Navbar.Brand> */}
                     {/* This toggle controls the Navbar.Collapse below */}
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    {/* Search Form (moves into collapse on small screens) */}

                    {/* Collapsible section */}
                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* Search Form for Mobile View */}
                       {/*  <Form className="d-flex d-md-none my-2">
                            <Form.Control type="search" placeholder={t('search') + '...'} className="me-2" />
                            <Button variant="outline-primary" size="sm"><FaSearch /></Button>
                        </Form> */}

                         {/* Navigation moved from Header Nav to Sidebar - add mobile sidebar links here if needed */}
                         {/* Example for mobile nav if sidebar is hidden: */}
                         {/* <Nav className="d-md-none">
                             <Nav.Link as={Link} to="/dashboard">{t('dashboard')}</Nav.Link>
                             <Nav.Link as={Link} to="/loans">{t('loans')}</Nav.Link>
                              ... other essential mobile links ...
                         </Nav> */}

                        {/* Right Aligned Items */}
                        <Nav className="ms-auto align-items-center header-icons">
                             {/* Placeholder Icons */}
                             {/* <Nav.Link href="#grid"><FaThLarge /></Nav.Link> */}
                             {/* <Nav.Link href="#comments"><FaRegCommentDots /></Nav.Link> */}
                             {/* <Nav.Link href="#notifications"><FaRegBell /></Nav.Link> */}

                            {/* Language Dropdown */}
                             <NavDropdown title={i18n.language === 'ar' ? t('arabic') : t('english')} id="basic-nav-dropdown-lang" align="end">
                               <NavDropdown.Item onClick={() => changeLanguage('en')}>{t('english')}</NavDropdown.Item>
                               <NavDropdown.Item onClick={() => changeLanguage('ar')}>{t('arabic')}</NavDropdown.Item>
                            </NavDropdown>

                             {/* User Profile Dropdown */}
                            {user && (
                                <NavDropdown
                                    title={
                                        <span className="user-profile">
                                            <Image src={placeholderAvatar} alt="User Avatar" roundedCircle />
                                            <span className="d-none d-lg-inline ms-1">{user.name}</span> {/* Show name on larger screens */}
                                        </span>
                                    }
                                    id="basic-nav-dropdown-user"
                                    align="end" // Align dropdown to the right
                                >
                                     <NavDropdown.Header>
                                         {user.name} <br/>
                                         <small className="text-muted">{t(`role_${user.role}`)}</small>
                                    </NavDropdown.Header>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item as={Link} to="/settings"><FaCog className="me-2"/>{t('settings')}</NavDropdown.Item>
                                    <NavDropdown.Item onClick={handleLogout}><FaSignOutAlt className="me-2"/>{t('logout')}</NavDropdown.Item>
                                </NavDropdown>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;